<template>
   <div class="titleBg">
        <div class="prev">
<!--          <div class="clickBtn" v-if="curNavId!='1'" @click="clickReturn"><img src="../assets/img/nav/syy.png" />上一页</div>-->
        </div>
        <div class="nav navLeft">
<!--          <router-link :to="{path:item.path}" v-for="(item,index) in navListLeft" :key="index"><div class="dh_lb_bt" :class="{dh_lb_bt_cur:curNavId==item.id}">{{item.name}}</div></router-link>-->
        </div>
<!--        <div class="logo"><router-link :to="{path:'/'}"><img src="../assets/img/plantfx1/bt.png" /></router-link></div>-->
          <div class="logo">
            <img src="../assets/img/plantfx1/bt.png" @click="circleShow('show')" />
<!--            <h5>梦莉娇质量安全追溯数据平台</h5>-->
          </div>
        <div class="nav navRight">
<!--          <router-link :to="{path:item.path}" v-for="(item,index) in navListRight" :key="index"><div class="dh_lb_bt" :class="{dh_lb_bt_cur:curNavId==item.id}">{{item.name}}</div></router-link>-->
        </div>
        <div class="next">
<!--          <router-link :to="{ path: pathUrl }"  ><div  class="clickBtn" v-if="curNavId!=8">下一页<img src="../assets/img/nav/xyy.png" /></div></router-link>-->
        </div>
<!--     <div class="caidan" @click="circleShow('show')"></div>-->
    </div>
</template>
<script>
import { ref, toRefs,reactive,onMounted } from "vue";
import { useRouter } from 'vue-router'

export default {
  name: "baseBar",
  props:['title','curNavId','pathUrl'],
  emits: ["circle"],
  setup(props,{emit}) {
    const router = useRouter();
    const state = reactive({
      navListLeft:[
        // {name:"项目概况",path:"/gbzntyj",id:1},
        {name:"建设进度",path:"/gbzntjs",id:2},
        {name:"种植现状",path:"/plant",id:3},
        {name:"智能管理",path:"/zhinengGG",id:6},
        // {name:"种植模型",path:"/plantmoxing",id:4}
        // {name:"种植规划",path:"/binghai"},
        // {name:"农产品溯源",path:"/suyuan"},  
      ],
      navListRight:[    
        {name:"灾害预警",path:"/qihouYj",id:5},
        {name:"病虫诊断",path:"/binghai",id:7},
        {name:"质量安全",path:"/suyuan",id:8},
        // {name:"农作物分析",path:"/zhinengGG",id:8},
        // {name:"种植规划",path:"/binghai"},
        // {name:"农产品溯源",path:"/suyuan"},  
      ],


    });
      // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    function circleShow(context){
      emit("circle",{show:true})
    }
    onMounted(() => {
     
      
    });
   
    return {
      ...toRefs(state),
      clickReturn,
      circleShow
    };
  },
};

</script>
<style lang="less" scoped>
.titleBg{
  width: 100%;
  height: 91px;
  background: url('../assets/img/nav/btbj.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  z-index: 1000;
  a{
    display: block;
    width: 100%;
    height: 100%;
  }
  .caidan{
    width: 64px;
    height: 26px;
    background: url("../assets/img/nav/xfq.png") no-repeat;
    position: absolute;
    //top: 30px;
    right: 20px;
    cursor: pointer;
    transition: all 0.5s ease-out;
    animation: opacity 1s linear infinite;
    transform: scale(1.2);
  }
  .caidan:hover{
    transform: scale(1.4);
  }
  .prev,.next{
    display: flex;
    color: #3BF4BE;
    font-size: 12px;
    width: 70px;
     a{color: #3BF4BE;}
    img{
      width: 16px;
      height: 12px;
    }
  }
  .prev{
    img{
      margin-right: 10px;
    }
  }
  .next{
      img{
      margin-left: 10px;
    }
  }
  .nav{
    flex: 1;
    height: 35px;
    display: flex;
    justify-content: center;
    padding: 0 10px;
    a{
      display: block;
      width: 103px;
      height: 35px;
      margin: 0 16px;
    }
    .dh_lb_bt {
      width: 103px;
      height: 35px;
      background: url("../assets/img/nav/wxz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      line-height: 35px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;

    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      cursor: pointer;
      background: url("../assets/img/nav/xz.png") no-repeat top center;
      background-size: 100% 100%;
      color: #fff;
    }
  }
  .logo{
    margin: 0 165px;
    //border: 1px solid;
    cursor: pointer;
    img{
      width: 438px;
      height: 38px;
    }
    h5{
      font-size: 32px;
      color: #fff;
      letter-spacing: 2px;
    }
  }
  }

@keyframes opacity {    /*引用动画名称*/
  0% {
    filter: drop-shadow(0 0 0px rgba(227, 197, 28, 0));
  }

  50% {
    filter: drop-shadow(0 0 1px rgba(21, 191, 173, 0.5));
  }
  100% {
    filter: drop-shadow(0 0 0px rgba(227, 197, 28, 0));
  }
}
</style>
